export default __webpack_public_path__ + "static/curriculum-44893a015b0f0a37a022ea1d82cea438.mp4";